import { Badge } from "@material-ui/core";
import { Bagde } from "components/Card";
import useText from "constants/text";
import {
  ParcelsBadgeButton,
  ParcelsBadgeContainer,
  ParcelsBadgeText,
  ParcelsCount,
  ParcelsCountText,
} from "domains/Dashboard/components/Styles";
import React, { ReactElement } from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    badgeStyle: {
      margin: "0 8px 2px 12px",
    },
    customBadge: {
      backgroundColor: "#fff",
      color: "#f2994a",
    }
  })
);




interface IBadgeButton {
  value: string | ReactElement;
  onClick: (element: any) => void;
  element: any;
  withoutBadgeStyle?: boolean;
}

export default function BadgeButton({ value, onClick, element, withoutBadgeStyle }: IBadgeButton) {
  const { text } = useText();
  const styles = useStyles();
  return (
    <ParcelsBadgeContainer onClick={() => onClick(element)}>
      {withoutBadgeStyle ? (
        <ParcelsCount>
          <ParcelsCountText>{text.all.parcels}  
          <Badge 
          classes={{ badge: styles.customBadge }}
          className={styles.badgeStyle} badgeContent={value || 0} color="secondary"></Badge>
          </ParcelsCountText>
        </ParcelsCount>
      ) : (
        <ParcelsBadgeButton>
          <Bagde value={value ?? "0"}  variante="contained" height={15} width={15} fontSize={8} />
          <ParcelsBadgeText>{text.all.show_parcels}</ParcelsBadgeText>
        </ParcelsBadgeButton>
      )}
    </ParcelsBadgeContainer>
  );
}
